export const enforcementLevelOptions = [
  { value: 'all', label: 'All changes' },
  { value: 'breaking', label: 'Breaking changes only' },
  { value: 'downstream', label: 'Downstream impact only' },
  { value: 'downstream_critical', label: 'Critical downstream impact only' },
];

export const thresholdUnitOptions = [
  { value: 'hour', label: 'hours' },
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

export const DEFAULT_ANOMALY_TRAINING_PERIOD = {
  period: 'day' as const,
  count: 23,
};
